import { AskRating as askRating } from './components';
import { TYPE_BUTTON_CLICK } from './customEventTypes';

const patchedShowDialog = (sf, sidebar, chatControl) => {
  const { labels } = sf;
  const { showDialog } = sidebar;

  return (params) => {
    const msgChatStateEnd = labels.MessageOverlay.ChatStateEnd;
    const { needsRating, ratings, translations } = chatControl;
    const firstButtonLabel = (params.buttons ?? {})[0]?.label;
    if (!needsRating || firstButtonLabel !== msgChatStateEnd) {
      showDialog(params);
      return;
    }

    showDialog({
      title: translations?.emailChatRateSubject,
      body: askRating(ratings).outerHTML,
      buttons: [{
        label: labels.MessageOverlay.ChatStateResume,
        flavor: 'inverse',
      }],
      temporaryHeading: labels.LiveAgentSidebarApp.LiveChat,
    });
  };
};

let ratingClickHandler;
const patchSidebar = (sf, chatControl) => {
  const sbId = Object.keys(sf.sidebarInstanceMap)[0];
  const sidebar = sf.sidebarInstanceMap[sbId];

  sidebar.showDialog = patchedShowDialog(sf, sidebar, chatControl);

  if (ratingClickHandler) {
    // With each chat session, an event handler is added and needs to be removed
    document.removeEventListener('click', ratingClickHandler, false);
  }
  ratingClickHandler = (event) => {
    if (event.target.matches('.sfChatAskRate .sfMenuButton')) {
      event.preventDefault();

      sf.liveAgentAPI.sendCustomEvent(TYPE_BUTTON_CLICK, JSON.stringify({
        type: 'RatingAnswer',
        value: event.target.dataset.value,
        closeChat: true,
      }));
    }
  };
  document.addEventListener('click', ratingClickHandler, false);
};

export default { patchSidebar };
